import React, { useEffect, useState, useCallback } from "react";
import { Context, Hooks, Util } from "@xt/xtbase";
import {
  getActivityContextSummary,
  getPublicActivityContextSummary,
  getActivityList,
} from "@/api/activity";
import { resolveCouponTenantId } from "@/api/coupon-user";
import { fetchUnusedCouponCount } from "@/components/Pages/Activity/Voucher/fetchUnusedCouponCount";
import { isHomeTaskCenterEntryVisible } from "@/utils/featureGrayRelease";
import VoucherIconSrc from "./icons/voucher.svg";
import styles from "./index.module.less";
import { observer } from "mobx-react-lite";
const { useTranslation } = Hooks;
const { getUrl } = Util;
const { XtContext } = Context;

function getDepositBonusPercent(summary) {
  const raw = summary?.depositBonus?.bonusPercent;
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? value : null;
}

function getClaimableCount(summary) {
  const value = Number(summary?.claimableCount);
  return Number.isFinite(value) && value > 0 ? value : 0;
}

function isOngoingActivityParticipating(activity) {
  const s = (activity?.userStatus || "").toUpperCase();
  return s !== "NOT_JOINED";
}

function isJoinActivityStillOpenByEndTime(activity, referenceMs = Date.now()) {
  const raw = activity?.endTime;
  if (raw == null || raw === "") return true;
  let ts = typeof raw === "string" ? Number(raw) : raw;
  if (!Number.isFinite(ts)) return true;
  if (ts > 0 && ts < 1e12) ts *= 1000;
  return ts >= referenceMs;
}

const DepositIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
    <path
      d="M13.4999 17.7998H3.90026C2.5748 17.7998 1.50029 16.7253 1.50026 15.3999L1.5 6.40007C1.49996 5.07456 2.57449 4 3.9 4H18.2994C19.625 4 20.6995 5.0739 20.6995 6.39942L20.6995 10.6M2.09954 8.19985H20.0995"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0995 15.3828L18.6081 16.8914L21.8995 13.5999"
      stroke="#45BF76"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReferralIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M11.1814 13.0596C8.91395 12.9869 7.11334 11.215 7.11334 9.03432C7.11334 6.80817 8.99969 5 11.3433 5C13.6775 5 15.5733 6.80817 15.5733 9.03432C15.5638 11.215 13.7632 12.9869 11.4958 13.0596C11.4005 13.0505 11.2862 13.0505 11.1814 13.0596Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.419 6.81732C20.2699 6.81732 21.7582 8.24387 21.7582 9.99753C21.7582 11.7148 20.3271 13.1141 18.543 13.1777C18.4667 13.1687 18.3808 13.1687 18.295 13.1777" stroke="#45BF76" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.73162 21.7461C9.3553 23.418 13.6581 23.418 16.2818 21.7461C18.5906 20.2741 18.5906 17.8753 16.2818 16.4124C13.6677 14.7496 9.36484 14.7496 6.73162 16.4124C4.42279 17.8844 4.42279 20.2832 6.73162 21.7461Z" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.2603 21.3553C20.9472 21.2191 21.5959 20.9555 22.1302 20.5648C23.6186 19.5017 23.6186 17.7481 22.1302 16.685C21.6055 16.3034 20.9663 16.0489 20.2889 15.9036" stroke="#45BF76" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const VoucherIcon = () => (
  <img src={VoucherIconSrc} alt="" className={styles["quick-actions__icon-img"]} />
);

const TaskCenterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M14.019 23.3073V9.34369M4.94263 14.231H22.7463C23.1319 14.231 23.4444 13.9184 23.4444 13.5328V10.0419C23.4444 9.65628 23.1319 9.34369 22.7463 9.34369H4.94263C4.55703 9.34369 4.24445 9.65628 4.24445 10.0419V13.5328C4.24445 13.9184 4.55703 14.231 4.94263 14.231ZM21.699 14.231V22.6091C21.699 22.9947 21.3864 23.3073 21.0008 23.3073H6.68808C6.30249 23.3073 5.9899 22.9947 5.9899 22.6091V14.231H21.699Z" stroke="white" strokeWidth="1.63104" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.394 8.506C12.5669 8.54479 12.7491 8.49724 12.8735 8.37278C12.998 8.24833 13.0455 8.06609 13.0067 7.89329C12.8516 7.25951 12.2801 5.13727 11.6932 4.5504C10.962 3.81924 9.77203 3.8162 9.04448 4.54374C8.31699 5.27123 8.31993 6.46123 9.05114 7.19244C9.64761 7.78891 11.7603 8.35086 12.394 8.506Z" stroke="#45BF76" strokeWidth="1.63104" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.1686 7.89324C14.1298 8.06611 14.1774 8.24828 14.3018 8.37274C14.4263 8.49719 14.6085 8.54467 14.7813 8.50595C15.4151 8.35079 17.5373 7.77926 18.1242 7.19239C18.8554 6.46123 18.8584 5.27123 18.1309 4.54369C17.4034 3.8162 16.2134 3.81914 15.4822 4.55035C14.8857 5.14682 14.3237 7.25948 14.1686 7.89324Z" stroke="#45BF76" strokeWidth="1.63104" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MoreIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10.4059 21.6H5.60586C4.28038 21.6 3.20586 20.5254 3.20587 19.2L3.20596 4.80001C3.20597 3.47453 4.28049 2.40002 5.60596 2.40002H16.4062C17.7317 2.40002 18.8062 3.47454 18.8062 4.80002V11.4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.4 21.1883V17.7941M17.4 17.7941V14.4M17.4 17.7941L14.0059 17.7941M17.4 17.7941L20.7941 17.7941" stroke="#45BF76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const HomeQuickActions = ({ onOpenDeposit }) => {
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const loginStatus = appState?.loginStatus;
  const userInfo = appState?.userInfo ?? null;
  const userId = userInfo?.userId;
  const search = typeof window !== "undefined" ? window.location.search : "";
  const showRewardHubEntry = isHomeTaskCenterEntryVisible(loginStatus, userId, userInfo, search);
  const [depositBonusPercent, setDepositBonusPercent] = useState(null);
  const [rewardHubClaimableCount, setRewardHubClaimableCount] = useState(0);
  const [rewardHubHasNew, setRewardHubHasNew] = useState(loginStatus !== 1);
  const [availableVoucherCount, setAvailableVoucherCount] = useState(0);
  const couponTenantId = React.useMemo(() => resolveCouponTenantId(appState), [appState]);
  const refreshActivityContextSummary = useCallback(async () => {
    if (loginStatus == null) return;
    try {
      const summary =
        loginStatus === 1
          ? await getActivityContextSummary()
          : await getPublicActivityContextSummary();
      setDepositBonusPercent(getDepositBonusPercent(summary));
      setRewardHubClaimableCount(getClaimableCount(summary));
    } catch (_) {
      setDepositBonusPercent(null);
      setRewardHubClaimableCount(0);
    }
  }, [loginStatus]);

  useEffect(() => {
    refreshActivityContextSummary();
  }, [refreshActivityContextSummary]);

  const refreshRewardHubNewBadge = useCallback(async () => {
    if (loginStatus == null) return;
    if (loginStatus !== 1) {
      setRewardHubHasNew(true);
      return;
    }
    try {
      const [ongoingList, joinList] = await Promise.all([
        getActivityList({
          params: { ongoingOnly: true },
          isAutoPopError: false,
        }),
        getActivityList({
          isAutoPopError: false,
        }),
      ]);
      const now = Date.now();
      const hasOngoing = (Array.isArray(ongoingList) ? ongoingList : []).some(isOngoingActivityParticipating);
      const hasJoinable = (Array.isArray(joinList) ? joinList : [])
        .filter((activity) => activity?.userStatus === "NOT_JOINED")
        .some((activity) => isJoinActivityStillOpenByEndTime(activity, now));
      setRewardHubHasNew(rewardHubClaimableCount > 0 || hasOngoing || hasJoinable);
    } catch (_) {
      setRewardHubHasNew(rewardHubClaimableCount > 0);
    }
  }, [loginStatus, rewardHubClaimableCount]);

  useEffect(() => {
    refreshRewardHubNewBadge();
  }, [refreshRewardHubNewBadge]);

  const refreshAvailableVoucherCount = useCallback(async () => {
    if (loginStatus !== 1 || userId == null || userId === "") {
      setAvailableVoucherCount(0);
      return;
    }
    try {
      const { ok, count } = await fetchUnusedCouponCount({
        tenantId: couponTenantId,
        userId: String(userId),
      });
      const n = ok ? Number(count) : 0;
      setAvailableVoucherCount(Number.isFinite(n) && n > 0 ? n : 0);
    } catch (_) {
      setAvailableVoucherCount(0);
    }
  }, [loginStatus, userId, couponTenantId]);

  useEffect(() => {
    refreshAvailableVoucherCount();
  }, [refreshAvailableVoucherCount]);

  const quickActions = [
    {
      id: "deposit",
      icon: <DepositIcon />,
      label: t("more.deposit") || "Deposit",
      onClick: () => onOpenDeposit?.(null),
      cornerBadge: depositBonusPercent != null ? `+${depositBonusPercent}%` : "",
    },
    {
      id: "referral",
      icon: <ReferralIcon />,
      label: t("home.referral") || "Referral",
      onClick: () => {
        window.location.href = getUrl("/referral");
      },
    },
    ...(showRewardHubEntry
      ? [
          {
            id: "rewardHub",
            icon: <TaskCenterIcon />,
            label: t("home.rewardHub") || "Reward Hub",
            onClick: () => {
              window.location.href = getUrl("/activity/reward-hub");
            },
            cornerBadge:
              rewardHubHasNew ? t("home.rewardHubNewBadge") || "New" : "",
          },
        ]
      : []),
    {
      id: "voucher",
      icon: <VoucherIcon />,
      label: t("home.voucher") || "Voucher",
      onClick: () => {
        window.location.href = getUrl("/activity/voucher");
      },
      cornerBadge: availableVoucherCount > 0 ? `X${availableVoucherCount}` : "",
      cornerBadgeVariant: "voucher",
    },
    {
      id: "more",
      icon: <MoreIcon />,
      label: t("home.more") || "More",
      onClick: () => {
        window.location.href = getUrl("/more");
      },
    },
  ];

  return (
    <>
      <div className={styles["quick-actions"]}>
        <div className={styles["quick-actions__container"]}>
          {quickActions.map((action) => (
            <button
              key={action.id}
              type="button"
              className={styles["quick-actions__item"]}
              onClick={action.onClick}
            >
              <div className={styles["quick-actions__icon-wrapper"]}>
                {action.icon}
                {action.cornerBadge ? (
                  <span
                    className={
                      action.cornerBadgeVariant === "voucher"
                        ? `${styles["quick-actions__corner-badge"]} ${styles["quick-actions__corner-badge--voucher"]}`
                        : styles["quick-actions__corner-badge"]
                    }
                  >
                    {action.cornerBadge}
                  </span>
                ) : null}
              </div>
              <span className={styles["quick-actions__label"]}>{action.label}</span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default observer(HomeQuickActions);
